/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_Wipe_Warning_AfterInputs */

const fr_vehicle_action_archive_wipe_warning_after = /** @type {(inputs: Vehicle_Action_Archive_Wipe_Warning_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` le numéro du véhicule est susceptible d'être réutilisé à court terme sur le réseau.`)
};

const en_vehicle_action_archive_wipe_warning_after = /** @type {(inputs: Vehicle_Action_Archive_Wipe_Warning_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` the vehicle number may be reused soon on the network.`)
};

/**
* | output |
* | --- |
* | "the vehicle number may be reused soon on the network." |
*
* @param {Vehicle_Action_Archive_Wipe_Warning_AfterInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_wipe_warning_after = /** @type {((inputs?: Vehicle_Action_Archive_Wipe_Warning_AfterInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Wipe_Warning_AfterInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_wipe_warning_after(inputs)
	return en_vehicle_action_archive_wipe_warning_after(inputs)
});